import { z } from 'zod';

export const NoteSchema = z.object({
  _id: z.string(),
  authorId: z
    .object({
      _id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
    })
    .or(z.string()),
  content: z.string(),
  hidden: z.boolean().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const NotesSchema = NoteSchema.array();

export type Note = z.infer<typeof NoteSchema>;

export const NoteFormSchema = z.object({
  note: z.string().min(1, 'Note cannot be empty'),
  hidden: z.boolean().optional(),
});

export type GetNotesRequest = string;
export type GetNotesResponse = Note[];

export const AddNoteResponseSchema = z.object({
  message: z.string(),
  note: z.object({
    authorId: z.string(),
    content: z.string(),
    hidden: z.boolean(),
  }),
});
export type AddNoteResponse = z.infer<typeof AddNoteResponseSchema>;
export interface AddNoteRequest {
  userId: string;
  content: string;
  hidden?: boolean;
}

export const UpdateNoteResponseSchema = AddNoteResponseSchema;
export type UpdateNoteResponse = z.infer<typeof UpdateNoteResponseSchema>;
export type UpdateNoteRequest = {
  userId: string;
  noteId: string;
  content?: string;
  hidden?: boolean;
};

export const UserDetailsSchema = z.object({
  _id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.string(),
  isEmailVerified: z.boolean(),
  lastLogin: z.string().nullable(),
  createdAt: z.string(),
  status: z.string(),
  organization: z.string().optional(),
  notes: NoteSchema.array(),
});
